/**
 * Size first, ribbon second
 * ------------------------------------------------------------------------------
 * Product pages with a Size and a Color option (the single-flavor toffees).
 * The Color list only shows ribbons that exist for the selected size. A size with
 * a single ribbon (4 oz printed ribbon) hides the Color row and selects that ribbon.
 * Markup: snippets/product-option-selector.liquid
 *
 * Runs in the capture phase, so the Color value is fixed before slate.Variants
 * (theme.js) reads the options on the same change event.
 */
(function() {
  var selectors = {
    container: '[data-section-type="product"]',
    size: '[data-ribbon-size] select',
    color: '[data-ribbon-color]',
    colorSelect: 'select'
  };
  var fixedClass = 'product-form__item--ribbon-fixed';

  function sizeNumber(value) {
    var number = parseFloat(value);
    return isNaN(number) ? Infinity : number;
  }

  function init(container) {
    var sizeSelect = container.querySelector(selectors.size);
    var colorWrapper = container.querySelector(selectors.color);
    var productJson = document.getElementById(
      'ProductJson-' + container.getAttribute('data-section-id')
    );

    if (!sizeSelect || !colorWrapper || !productJson) return;
    if (container.hasAttribute('data-ribbon-ready')) return;
    container.setAttribute('data-ribbon-ready', '');

    var colorSelect = colorWrapper.querySelector(selectors.colorSelect);
    var variants = JSON.parse(productJson.textContent).variants;
    var sizeKey = sizeSelect.getAttribute('data-index');
    var colorKey = colorSelect.getAttribute('data-index');

    function colorsFor(size) {
      var colors = [];
      variants.forEach(function(variant) {
        var color = variant[colorKey];
        if (variant[sizeKey] === size && colors.indexOf(color) === -1) {
          colors.push(color);
        }
      });
      return colors;
    }

    function update() {
      var currentColor = colorSelect.value;
      var colors = colorsFor(sizeSelect.value);
      if (!colors.length) return;

      colorSelect.innerHTML = '';
      colors.forEach(function(color) {
        var option = document.createElement('option');
        option.value = color;
        option.textContent = color;
        colorSelect.appendChild(option);
      });
      colorSelect.value =
        colors.indexOf(currentColor) > -1 ? currentColor : colors[0];

      colorWrapper.classList.toggle(fixedClass, colors.length === 1);
    }

    // Sizes small to large (one product lists 8 oz, 16 oz, 4 oz)
    var selectedSize = sizeSelect.value;
    Array.prototype.slice
      .call(sizeSelect.options)
      .sort(function(a, b) {
        return sizeNumber(a.value) - sizeNumber(b.value);
      })
      .forEach(function(option) {
        sizeSelect.appendChild(option);
      });
    sizeSelect.value = selectedSize;

    update();

    container.addEventListener(
      'change',
      function(evt) {
        if (evt.target === sizeSelect) update();
      },
      true
    );
  }

  function initAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll(selectors.container),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor re-renders the section
  document.addEventListener('shopify:section:load', initAll);
})();
